const global = global || window;
const {createPipeline} = require("cleopatra");
const env = require("app/services/env");
const documentReady = require("app/util/documentReady");
const csrfToken = require("app/services/csrfToken");
const {reportOnly} = require("app/util/errors");
const router = require("app/services/router");
const browser = require("app/services/browser");

// Create pipelines
let ready = createPipeline().report(reportOnly);
let bootstrap = createPipeline().report(reportOnly).capture(ready);

module.exports = bootstrap;

/////////////////////////////////
// Moment
/////////////////////////////////
bootstrap.pipe(payload => {
    const locale = env.get('locale', 'da');
    const moment = require("moment-timezone");

    // Unfortunately dynamic paths can't be used to require the necessary locale files
    switch (locale) {
      case 'da':
        require(`moment/locale/da`);
        break;
      case 'de':
        require(`moment/locale/de`);
        break;
    }

    moment.locale(locale);
    moment.suppressDeprecationWarnings = true;

	return payload;
});

/////////////////////////////////
// Renderer
/////////////////////////////////

const renderer = require("app/services/renderer");

// Do not boot if server side
bootstrap.pipe(payload => env.client() ? payload : false);

ready.pipe(payload => {
	renderer.render();
	return payload;
});

/////////////////////////////////
// document.ready
/////////////////////////////////

bootstrap.pipe(payload => documentReady(payload));

/////////////////////////////////
// Add browser class to body
/////////////////////////////////

bootstrap.pipe(payload => {
	let classList = document.body.className.split(" ");
	const {name, version} = browser;

	classList.push(`browser-${name}`);
	classList.push(`browser-${name}-${version}`);

	document.body.className = classList.join(" ");

	return payload;
});

/////////////////////////////////
// Refresh if timestamp is to old
/////////////////////////////////
const moment = require("moment");

/*bootstrap.pipe(payload => {
 if (moment(env.get("ts"), "YYYY-MM-DD HH:mm:ss").add(30, "second").isBefore(moment())) {
 window.location = router.currentUrl;
 window.location.reload();

 return false;
 }

 return payload;
 });*/

/////////////////////////////////
// axios
/////////////////////////////////

const axios = require("axios");

bootstrap.pipe(payload => {
	// Specify the X-Request-With header so that the Laravel backend knows
	// we are requiring it through ajax
	axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

	// Register the CSRF token provided by Laravel
	// This will also act as our main authentication method
	// for Passport
	let token = csrfToken();

	if (token == undefined) {
		throw new Error("Cannot setup axios because the CSRF token is missing!");
	}

	axios.defaults.headers.common['X-CSRF-TOKEN'] = token;

	return payload;
});

/////////////////////////////////
// Preloader
/////////////////////////////////
/*
const preloader = require("app/services/preloader");

if (!env.server()) {
	preloader.hide();
}

ready.capture(payload => {
	if (env.server()) {
		preloader.hide();
	}

	return payload;
});
*/
